import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function SamplePreviewModal({ isOpen, name, url, onClose }) {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="md">
      <ModalHeader toggle={onClose}>{name || "Sample"}</ModalHeader>
      <ModalBody className="p-0">
        {url ? (
          <img
            src={url}
            alt={name || "Sample"}
            className="img-fluid w-100"
          />
        ) : null}
      </ModalBody>
    </Modal>
  );
}

